<template>
  <div :class="{ 'preview-mhe': file.contentType === 'mhe', previewMain: !isVideoCanPreview }">
    <video-preview v-if="isVideoCanPreview" :url="file.downloadUrl" :isShare="true" />
    <main v-loading="isLoading" v-else>
      <PreviewContent
        @showLogin="$emit('showLogin')"
        v-if="isCanPreviw"
        :fileItem="file"
        :user="user"
        :isVideoCanPreview="isVideoCanPreview"
      />
      <div v-show="!isLoading && !isCanPreviw" class="tip-body">
        <img :src="resultIcon" alt="" />
        <div class="main-tip">{{ mainTip }}</div>
        <div>{{ subTip }}</div>
        <el-button type="primary" v-if="showDownloadButton && user.userId" @click="downloadFile">下载</el-button>
      </div>
    </main>
  </div>
</template>

<script>
import VideoPreview from '@business/Preview/VideoPreview/VideoPreview';
import PreviewContent from './PreviewContent/PreviewContent';
import Constants from '@constants';
import { AIRDISK } from '@services';

const authorityIcon = require('@assets/images/web/icon_file_encryption.png');
const failIcon = require('@assets/images/web/icon_file_fail.png');

export default {
  name: 'PreviewMain',
  components: {
    PreviewContent,
    VideoPreview
  },
  props: {
    showOpenAppTip: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: () => {}
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    file(data) {
      if (!data) return;
      this.file = data;
      const code = data.code;
      if (code === 200) {
        const contentType = data.contentType.toLowerCase();
        const { SUPPORTED_PREVIEW_TYPES, SUPPORTED_PREVIEW_VIDEO_TYPES } = Constants.Common;
        const isVideoType = SUPPORTED_PREVIEW_VIDEO_TYPES.includes(contentType);

        // 视频文件要需要登录才能预览
        this.isVideoCanPreview = isVideoType && !!this.user.userId;

        // 视频文件设置对应视频CSS
        this.isVideoCanPreview && this.setVideoCss();

        const isCanPreview = SUPPORTED_PREVIEW_TYPES.includes(contentType) || this.isVideoCanPreview;

        if (!isCanPreview) {
          this.isCanPreviw = false;
          this.mainTip = isVideoType ? '视频文件需要登录才能预览' : '此文件类型不支持预览';
          this.showDownloadButton = true;
          this.resultIcon =
            Constants.Common.ICONTYPES.large[data.contentType] || Constants.Common.ICONTYPES.large['unknown'];
          if (data.itemId) AIRDISK.Airdisk.reportPreview({ fileId: data.itemId });
        } else {
          const isOverSize = data.size > 100 * 1024 * 1024; // 由于使用了希沃那边的服务，过大文件无法正常返回，所以当文件大小超过100M时，提示文件过大，无法查看
          if (isOverSize) {
            this.mainTip = '文件过大，无法查看';
          } else {
            this.isCanPreviw = true;
          }
        }
      } else if (code === 403 || code === Constants.StatusCode.NO_FILE_PERMISSION) {
        // 拥有者永远拥有查看权限
        if (this.isOwner) {
          this.file = this.file;
          const isOverSize = this.file.size > 100 * 1024 * 1024; // 由于使用了希沃那边的服务，过大文件无法正常返回，所以当文件大小超过100M时，提示文件过大，无法查看
          if (isOverSize) {
            this.mainTip = '文件过大，无法查看';
          } else {
            this.isCanPreviw = true;
          }
        } else {
          // 没有权限查看
          this.resultIcon = authorityIcon;
          this.mainTip = '权限变更';
          this.subTip = '此文件的权限已发生变化，不可查看';
        }
      } else if (code === 404) {
        this.mainTip = '文件失效';
        this.subTip = '此文件已被删除或已过期，无法继续查看';
      }
      this.handleSetTitle(this.file.name);

      // if (data.contentType && data.itemId) {
      //   console.log('来到了这里，++++++', data.contentType);
      //   if (Constants.Common.IMGTYPE.includes(data.contentType.toLowerCase())) {
      //     console.log('图片，---- ', data.contentType);
      //     // 如果是图片类型，那么就上报数据浏览接口
      //     AIRDISK.Airdisk.reportPreview({ fileId: data.itemId });
      //   }
      // }
    }
  },
  data() {
    return {
      isCanPreviw: false,
      resultIcon: failIcon,
      mainTip: '文件加载失败', // 默认为文件加载失败
      subTip: '',
      startLoadPageTime: 0,
      showDownloadButton: false,
      isVideoCanPreview: false
    };
  },
  created() {
    this.postInfoToFriday();
  },
  methods: {
    setVideoCss() {
      const mainEl = document.getElementsByClassName('el-main')[0];
      const previewMainEl = document.getElementsByClassName('preview-main')[0];
      mainEl.style.flex = '1';
      mainEl.style.height = '100%';
      previewMainEl.style.height = '100%';
      previewMainEl.style.width = '100%';
    },
    handleSetTitle(title) {
      document.title = title || '文件预览';
    },
    postInfoToFriday() {
      const fileItem = this.file;
      const fileSize = fileItem.size ? (fileItem.size / 1024 / 1024).toFixed(2) : '';
      const params = {
        file_format: fileItem.contentType || '',
        file_size: fileSize
      };
      this.$pushData('WEB_PREVIEW_FILE', params);
      console.log(JSON.stringify(params));
    },
    downloadFile() {
      window.open(this.file.downloadUrlWithName);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './PreviewMain.scss';
</style>
